import React from 'react';
import PropTypes from 'prop-types';

import playBtn from '../../images/play-btn.svg';

import './CarouselItem.scss';

const CarouselItem = ({ name, title, text, image, video }) => (
  <div
    className={`carousel-item col col-4 flex flex-col justify-space-between rounded ${
      video ? 'video-item' : ' '
    }`}>
    {video ? (
      <img src={video} className="video" alt="" />
    ) : (
      <p className="text">{text}</p>
    )}
    {video && <img src={playBtn} className="play-btn" alt="" />}
    <div className={`person flex ${video ? 'is-video' : ' '}`}>
      {image && <img src={image} className="image" alt="" />}
      <div className="details">
        <p className="name">{name}</p>
        <div className="title">{title}</div>
      </div>
    </div>
  </div>
);

CarouselItem.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string,
  video: PropTypes.string,
};

export default CarouselItem;
